import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-365">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-366">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-367" />

          {/* Modal content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[80vh] bg-card border border-card-border rounded-2xl shadow-2xl flex flex-col overflow-hidden" data-id="element-368">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-card-border shrink-0" data-id="element-369">
              <h2 className="text-xl font-bold text-white" data-id="element-370">{title}</h2>
              <button onClick={onClose} className="w-10 h-10 rounded-full bg-background flex items-center justify-center text-gray-400 hover:text-white hover:bg-card-border transition-colors" aria-label="Cerrar" data-id="element-371">
                <XIcon className="w-5 h-5" data-id="element-372" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 overflow-y-auto text-gray-300 leading-relaxed space-y-4" data-id="element-373">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}